
    <button routerLink="/potatoes" routerLinkActive="active" skipLocationChange>Potatoes</button>


    <button routerLink="/spuds" routerLinkActive="active" skipLocationChange>spuds</button>


    <button routerLink="/tasks" routerLinkActive="active" skipLocationChange>tasks</button>
